import useTranslation from '@/hooks/useTranslation';
import classNames from '@/utils/classNames';
import type { FCl } from 'react-fc';
import styles from './LiveNow.module.css';

export const LiveNow: FCl = ({ className }) => {
    const { t } = useTranslation('common');
    return <p className={classNames(styles.text, className)}>{t('liveNow')}</p>;
};
